import * as PIXI from 'pixi.js'
import { clear } from '../utils'

export default function DetectResult(layerInfo, options, container) {
  clear(container)

  const yamlData = layerInfo.data.data
  const width = options.width
  const height = options.height
  const box = options.box
  const cols = yamlData.cols
  const rows = yamlData.rows
  const realData = yamlData.data

  const blockHeight = (height - box.top - box.bottom) / rows
  const blockWidth = (width - box.right - box.left) / cols

  const colors = {
    0: [0x000000, 0],
    1: [0x009fff, 0.196],
    2: [0xfdb240, 0.39],
    3: [0xec1010, 0.39],
    4: [0xffff00, 0.39],
    5: [0xff0000, 0.39],
    6: [0x802a2a, 0.39],
    7: [0xff6100, 0.39],
    8: [0x1e90ff, 0.39],
    9: [0x696969, 0.39],
    10: [0x3cb371, 0.39],
    11: [0x00ff7f, 0.39],
  }

  for (let i = 0, j = realData.length; i < j; i++) {
    const curValue = realData[i]
    if (curValue === 0) continue
    const row = Math.floor(i / cols)
    const col = i % cols
    const x = col * blockWidth
    const y = row * blockHeight + (Number(box.top) || 0)
    let rectangle = new PIXI.Graphics()
    rectangle.beginFill(...colors[curValue])
    rectangle.drawRect(0, 0, blockWidth, blockHeight)
    rectangle.endFill()
    rectangle.x = x
    rectangle.y = y
    container.addChild(rectangle)
  }
  return container
}
